import Product from "./product";
import loginStatus from "./loginStatus";
import garment from "./allproducts";
import tprice from "./tprice";
import customerProducts from "./customerProducts";
import draftId from "./draftId";
import { combineReducers } from "redux";
import campaign from "./campaigns";
import langStatus from "./lang";
const rootreducer = combineReducers({
	product: Product,
	login: loginStatus,
	garment: garment,
	customerProducts: customerProducts,
	campaign: campaign,
	tprice: tprice,
	draftId: draftId,
	language:langStatus
});

export default rootreducer;
